import { useIsLoggedOn } from "./useIsLoggedOn";
import { useNullableDealerAccountInfo } from "./useNullableDealerAccountInfo";

export const useHunterTireSetting = (): boolean => {
  const isLoggedOn = useIsLoggedOn();
  const dealer = useNullableDealerAccountInfo();

  if (!isLoggedOn || !dealer?.dealerHunterTireIntegrationEnabled) {
    return false;
  }

  return true;
};
